module.exports = __webpack_public_path__ + "static/media/software-engineering-cta-background.794f7b39.svg";